import axios from "axios";

// Create an Axios instance
const api = axios.create({
  baseURL: "https://d2j4ehygda.execute-api.ap-southeast-2.amazonaws.com/prod/", // Your backend server base URL
  // baseURL:"http://localhost:3000",
  headers: {
    "Content-Type": "application/json", // Default content type if needed
  },
});

// Define the function to get the QR code
export const getQRCode = async (token) => {
 
  
  const data = {
    location_id: token,
  };

  try {
    // Send POST request to the server-v2
    const response = await api.post("/login", data,{
      timeout: 1800000 // 10 seconds
    });
    
    return response; // Assuming the QR code is in the response data
  } catch (error) {

    return error?.response; // Re-throw the error so it can be handled elsewhere
  }
};
